import PropTypes from 'prop-types';
import { Checkbox, FormControlLabel } from '@mui/material';

function CheckBox({ onChange, label, checked, defaultChecked }) {
    if (checked !== null) {
        return (
            <FormControlLabel
                label={label}
                control={
                    (
                        <Checkbox
                            checked={checked}
                            onChange={onChange}
                        />
                    )
                }
            />
        );
    }
    return (
        <FormControlLabel
            label={label}
            control={
                (
                    <Checkbox
                        defaultChecked={defaultChecked}
                        onChange={onChange}
                    />
                )
            }
        />
    );
}

CheckBox.propTypes = {
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    checked: PropTypes.bool,
    defaultChecked: PropTypes.bool,
};

CheckBox.defaultProps = {
    checked: null,
    defaultChecked: null,
};

export default CheckBox;
